import ApiResource from "../../../Lib/ApiResource";

export default class AuthResource extends  ApiResource {

    constructor() {
        super();
        this.baseuri = '/';
    }

    login(credentials) {
        return this.post('login', credentials);
    }

    logout() {
        return this.post('logout');
    }

    register(credentials) {
        return this.post('register', credentials);
    }

    forgotPassword(email) {
        return this.post('password/email', email)
    }

    resetPassword(credenitals) {
        return this.post('password/reset', credenitals);
    }

    catch() {}

}
